import React from 'react';
import styled from "styled-components";
import ChampionDetailMasteryFilter from "./ChampionDetailMasteryFilter";
import ChampionDetailMasteryTable from "./ChampionDetailMasteryTable";
import useChampionMasteryQuery from "../../../common/hooks/useChampionMasteryQuery";
import {useParams} from "react-router-dom";
import {capitalizeLetter} from "../../../function";
import {ErrorBoundary} from "react-error-boundary";
import UseSetCanonical from "../../../common/hooks/useSetCanonical";
import useTitleAndDescription from "../../../common/hooks/useTitleAndDescription";
import {useTranslation} from "react-i18next";


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 80vh;
`;


const FilterWrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 12px;
`;

const LoadingWrapper = styled.div`
  height: 100px;
`;
const TableWrapper = styled.div`
  min-height: 300px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-radius: 6px;
  overflow: hidden;
`;

const ChampionDetailMastery = ({champion}) => {
    UseSetCanonical();
    const {t} = useTranslation();
    const search = useParams();
    const lane = search?.position ? capitalizeLetter(search?.position) : 'All';
    const champion_id = champion?.champion_id;
    const {ranks, isLoading} = useChampionMasteryQuery({champion_id, lane});


    useTitleAndDescription({
        title: t('header.titleChampionOtp', {
            champion: champion?.champion_name
        }),
        description: t('header.titleChampionOtpDescription', {
            champion: champion?.champion_name
        })
    })


    return (
        <Wrapper>
            <FilterWrapper>
                <ChampionDetailMasteryFilter/>
            </FilterWrapper>
            <TableWrapper>
                {isLoading ? <LoadingWrapper/> :
                    <ErrorBoundary fallback={<div>something went wrong...</div>}>
                        <ChampionDetailMasteryTable pageValue={100} ranks={ranks}/>
                    </ErrorBoundary>
                }
            </TableWrapper>
        </Wrapper>
    );
};

export default ChampionDetailMastery;